const EMAIL_MASK = "XXX";

// Used anywhere we need a safe, user-visible version of an email address.
export function maskEmail(email: string): string {
  const trimmedEmail = email.trim();
  const [localPart = "", domain = ""] = trimmedEmail.split("@");

  if (!localPart || !domain) {
    return trimmedEmail;
  }

  if (localPart.length <= 2) {
    return `${localPart[0] ?? ""}${EMAIL_MASK}@${domain}`;
  }

  return `${localPart.slice(0, 2)}${EMAIL_MASK}@${domain}`;
}
